import { E as EmblaCarousel } from './embla-carousel.esm-CCUHK2kO.js';
import { a as addScrollBarListener } from './scrollbar-CN2h-3bU.js';

class USPSlider extends HTMLElement {
  /** @type {import('embla-carousel').EmblaCarouselType} */
  #embla;

  connectedCallback() {
    this.#embla = EmblaCarousel(this.querySelector('.embla__viewport'), {
      align: 'center',
      dragFree: true,
      direction: document.dir,
      slidesToScroll: 'auto',
      active: true,
      breakpoints: {
        '(min-width: 80rem)': { active: false },
      },
    });

    addScrollBarListener(this.#embla, this.querySelector('.embla__scrollbar'));
  }
}

customElements.define('usps-slider', USPSlider);
